import { Category } from "~/models/category"
import { defineStore } from "pinia"
import { ApiResponse } from "~/types/api"

export const useCategoryStore = defineStore("category", () => {
	const state = {
		articleCategories: ref<Category[]>([]),
		categories: ref<Category[] | null>(null)
	}

	const createCategory = async (formData: CreateCategoryRequest) => {
		const data = await $fetch<CreateCategoryResponse>(CreateCategory.url(), {
			...useFetchConfig(),
			method: CreateCategory.method,
			body: formData
		})
		return data.data
	}

	const editCategory = async (formData: EditCategoryRequest) => {
		const data = await $fetch<EditCategoryResponse>(EditCategory.url(), {
			...useFetchConfig(),
			method: EditCategory.method,
			body: formData
		})
		return data.data
	}

	const deleteCategory = async (id: number) => {
		const data = await $fetch<DeleteCategoryResponse>(DeleteCategory.url(id), {
			...useFetchConfig(),
			method: DeleteCategory.method
		})
		return data.data
	}

	const searchCategories = async (formData: SearchCategoriesRequest) => {
		const data = await $fetch<SearchCategoriesResponse>(SearchCategories.url(), {
			...useFetchConfig(),
			method: SearchCategories.method,
			query: formData
		})
		return data.data
	}

	const getCategory = async (id: number) => {
		const data = await $fetch<GetCategoryResponse>(GetCategory.url(id), {
			...useFetchConfig(),
			method: GetCategory.method
		})
		return data.data
	}

	return {
		...state,
		createCategory,
		editCategory,
		deleteCategory,
		searchCategories,
		getCategory
	}
})

// category :: create category
export interface CreateCategoryRequest {
	title: string
	slug: string
	type: string
	locale: string
	color?: string | null
	content?: string | null
	parent_id?: number | null
	image_id?: number | null
}
export interface CreateCategoryResponse extends ApiResponse {
	data: Category
}
const CreateCategory = {
	method: "POST" as "POST",
	url: () => `categories/create`
}

// category :: edit category
export interface EditCategoryRequest {
	id: number
	title: string
	slug: string
	type: string
	locale: string
	color?: string | null
	content?: string | null
	parent_id?: number | null
	image_id?: number | null
}
export interface EditCategoryResponse extends ApiResponse {
	data: Category
}
const EditCategory = {
	method: "POST" as "POST",
	url: () => `categories/edit`
}

// category :: delete category
export interface DeleteCategoryRequest {}
export interface DeleteCategoryResponse extends ApiResponse {}
const DeleteCategory = {
	method: "POST" as "POST",
	url: (id: any) => `categories/delete/${id}`
}

// category :: search categories
export interface SearchCategoriesRequest {
	type?: string
	locale?: string
	parent_id?: number | null
	level?: number | null
}
export interface SearchCategoriesResponse extends ApiResponse {
	data: {
		categories: Category[]
		total: number
	}
}
export const SearchCategories = {
	method: "GET" as "GET",
	url: () => `categories/search`
}

// category :: get category
export interface GetCategoryRequest {}
export interface GetCategoryResponse extends ApiResponse {
	data: Category
}
const GetCategory = {
	method: "GET" as "GET",
	url: (id: any) => `categories/${id}`
}

export const useCategoryApiUrl = () => ({
	CreateCategory,
	EditCategory,
	DeleteCategory,
	SearchCategories,
	GetCategory
})
